import { axios } from './axios';
import store from '../store/store';

/**
 * TRS Registration API Service
 * Provides methods for managing TRS registrations
 */

export const trsRegistrationApi = {
    /**
     * Get all registrars for a company
     * @param {string} companyId - The company ID
     * @returns {Promise<Array>} Array of registrar objects
     */
    getRegistrars: async (companyId) => {
        const response = await axios.get(`/TRSRegistrars/${companyId}`);
        return response.data;
    },

    /**
     * Get TRS registrations by registrar ID
     * @param {string} registrarId - The registrar ID to filter by
     * @returns {Promise<Array>} Array of registration objects
     */
    getRegistrationsByRegistrar: async (registrarId) => {
        const response = await axios.get(`/TRSRegistrations/${registrarId}`);
        return response.data;
    },

    /**
     * Create a new TRS registration
     * @param {Object} data - Registration data
     * @param {string} data.registrar - Registrar ID
     * @param {string} data.extension - Extension number
     * @param {string} data.username - Username
     * @param {string} data.password - Password
     * @param {boolean} data.enabled - Enabled status
     * @param {string} data.companyID - Company ID
     * @returns {Promise<Object>} Created registration object
     */
    createRegistration: async (data) => {
        const requiredScope = store.getState().login?.requiredScope;
        const response = await axios.post('/TRSRegistration', data, {
            headers: {
                'X-RequestScope': requiredScope,
            },
        });
        return response.data;
    },

    /**
     * Update an existing TRS registration
     * @param {Object} data - Updated registration data
     * @param {string} data.registrar - Registrar ID
     * @param {string} data.extension - Extension number
     * @param {string} data.username - Username
     * @param {string} data.password - Password
     * @param {boolean} data.enabled - Enabled status
     * @param {boolean} data.delete - Delete flag
     * @param {string} data.companyID - Company ID
     * @returns {Promise<Object>} Updated registration object
     */
    updateRegistration: async (data) => {
        const requiredScope = store.getState().login?.requiredScope;
        const response = await axios.put('/TRSRegistration', data, {
            headers: {
                'X-RequestScope': requiredScope,
            },
        });
        return response.data;
    },

    /**
     * Delete a TRS registration
     * @param {string} registrationId - The registration ID to delete
     * @returns {Promise<Object>} Delete response
     */
    deleteRegistration: async (registrationId) => {
        const requiredScope = store.getState().login?.requiredScope;
        const response = await axios.delete(
            `/TRSRegistration/${registrationId}`,
            {
                headers: {
                    'X-RequestScope': requiredScope,
                },
            },
        );
        return response.data;
    },
};
